<template>
  <div class="form-group">
    <select class="form-control" @change="onChange()" v-model="key">
      <option
        :value="expense.slug"
        v-for="expense in expenses"
        :selected="currentExpense == expense.slug"
      >{{ expense.name }}</option>
    </select>
    <!-- /.form-control -->
  </div>
  <!-- /.form-group -->
</template>

<script>
  import axios from 'axios';
  import env from '../../../config/env';

  export default {
    name: 'expenses-filter',
    data () {
      return {
        expenses: [],
        key: '',
        currentExpense: '',
      }
    },
    methods: {
      onChange() {
        let route = this.$route.name;

        if (route === 'despesas-mes') {
          this.$router.push({
            name: 'despesas-mes',
            params: {
              branch: this.$route.params.branch,
              year: this.$route.params.year,
              category: this.key,
            }
          });
        } else if (route === 'despesas-internas') {
          this.$router.push({
            name: 'despesas-internas',
            params: {
              branch: this.$route.params.branch,
              year: this.$route.params.year,
              category: this.key,
              month: this.$route.params.month
            }
          });
        }
      }
    },
    mounted () {
      axios
        .get(env.api.DESPESAS)
        .then(response => {
          this.expenses = response.data;
          this.key = this.$route.params.category;
          this.currentExpense = this.$route.params.category;
        });
    }
  };
</script>

<style lang="scss" scoped>
  input,
  select,
  .btn {
    box-shadow: none !important;
  }

  input,
  select {
    height: 40px;

    box-shadow: none;
  }
</style>
